import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import axios from "axios";
import Loader from "../components/Loader";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function AdminDashboard() {
  const getRole = Cookies.get("user_role");
  const getUsername = Cookies.get("username");

  const GET_USERS = BASE_URL + "/getusers";
  const GET_PLAYERS = BASE_URL + "/getplayers";
  const GET_EVENTS = BASE_URL + "/getevents";
  const REALTIME_USERS = BASE_URL + "/getactiveusers";

  const [users, setUser] = useState([]);
  const [players, setPlayers] = useState([]);
  const [approvedPlayers, setApprovedPlayers] = useState([]);
  const [events, setEvents] = useState([]);
  const [activeUsers, setActiveUsers] = useState("");
  const [coachSportCategory, setCoachSportCategory] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        // Fetch Coach's SportCategory first if role is Coach
        if (getRole === "Coach") {
          const resUsers = await axios.get(GET_USERS, { headers: { Authorization: apiKey } });
          const coach = resUsers.data.find((u) => u.Name === getUsername && u.Role === "Coach");
          if (coach) setCoachSportCategory(coach.SportCategory || "");
        }

        // Administrator: fetch users
        if (getRole === "Administrator") {
          const resUsers = await axios.get(GET_USERS, { headers: { Authorization: apiKey } });
          setUser(resUsers.data);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchDashboardData();
  }, []);

  useEffect(() => {
    const fetchPlayersEvents = async () => {
      try {
        // Fetch players
        const playersUrl =
          getRole === "Coach" && coachSportCategory
            ? `${GET_PLAYERS}?sportCategory=${coachSportCategory}`
            : GET_PLAYERS;

        const resPlayers = await axios.get(playersUrl, { headers: { Authorization: apiKey } });
        setPlayers(resPlayers.data);
        setApprovedPlayers(resPlayers.data.filter((p) => p.Status === "Approved"));

        // Administrator: fetch events and realtime users
        if (getRole === "Administrator") {
          const resEvents = await axios.get(GET_EVENTS, { headers: { Authorization: apiKey } });
          setEvents(resEvents.data);

          const resRealtime = await axios.get(REALTIME_USERS, { headers: { Authorization: apiKey } });
          setActiveUsers(resRealtime.data.number);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    // Fetch players/events only after coachSportCategory is known (for Coach)
    if (getRole === "Coach" && !coachSportCategory) return;
    fetchPlayersEvents();
  }, [coachSportCategory]);

  if (loading) return <Loader />;

  return (
    <div className="container">
      <h2>Welcome, "{getUsername}"</h2>
      <br />
      <div className="row">
        {getRole === "Administrator" && (
          <>
            <div className="card" style={{ width: "20rem", margin: "10px" }}>
              <div className="card-body">
                <h5 className="card-title">Current Users</h5>
                <h4 className="card-subtitle mb-2 text-success">{users.length}</h4>
                <Link to="users" className="card-link">Manage Users</Link>
              </div>
            </div>

            <div className="card" style={{ width: "20rem", margin: "10px" }}>
              <div className="card-body">
                <h5 className="card-title">Total Events</h5>
                <h4 className="card-subtitle mb-2 text-success">{events.length}</h4>
                <Link to="events" className="card-link">Manage Events</Link>
              </div>
            </div>
          </>
        )}

        <div className="card" style={{ width: "20rem", margin: "10px" }}>
          <div className="card-body">
            <h5 className="card-title">Total Player Entries</h5>
            <h4 className="card-subtitle mb-2 text-success">{players.length}</h4>
            <Link to="players" className="card-link">Manage Players</Link>
          </div>
        </div>

        <div className="card" style={{ width: "20rem", margin: "10px" }}>
          <div className="card-body">
            <h5 className="card-title">Approved Certificates</h5>
            <h4 className="card-subtitle mb-2 text-success">{approvedPlayers.length}</h4>
            <Link to="certificates" className="card-link">View Certificates</Link>
          </div>
        </div>
      </div>

      {getRole === "Administrator" && <h3>Realtime Users: {activeUsers}</h3>}
    </div>
  );
}
